import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const HomeCat = (props) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const SkeletonItem = () => (
    <div className="group scale-[0.7] md:scale-[1] text-center">
      <div className="border overflow-hidden flex justify-center items-center w-[120px] h-[120px] md:w-[120px] md:h-[120px] rounded-[8px] md:rounded-full p-4 bg-gray-200 animate-pulse">
        <div className="w-[50px] md:w-[80px] md:h-[80px] h-[50px] bg-gray-300 rounded-full"></div>
      </div>
      <div className="mt-2 w-16 h-4 bg-gray-300 rounded mx-auto"></div>
    </div>
  );

  return (
    <section className="homeCat pb-0 sm:pb-2 ">
      <div className="container">
        <h3 className="mb-1 sm:mb-3 text-center md:text-3xl font-bold">
          Featured Categories
        </h3>
        <div className="w-full justify-start sm:gap-8 md:justify-center overflow-x-auto flex items-center ms-[-20px] md:ms-0 md:p-3">
          {loading
            ? // Skeleton loading
              Array(5)
                .fill(0)
                .map((_, index) => <SkeletonItem key={index} />)
            : // Actual content
              props.catData?.length !== 0 &&
              props.catData?.map((cat, index) => (
                <div
                  className="group scale-[0.7] md:scale-[1] text-center"
                  key={index}
                >
                  <Link to={`/products/category/${cat._id}`}>
                    <div
                      className="border overflow-hidden flex justify-center items-center w-[120px] h-[120px] md:w-[120px] md:h-[120px] rounded-[8px] md:rounded-full p-4 hover:shadow-lg transition-all duration-300"
                      style={{ background: cat.color }}
                    >
                      <img
                        src={cat?.images[0]}
                        className="w-[100px] md:w-[80px] md:h-[80px] group-hover:scale-[1.2] duration-150 h-[80px]"
                        alt={cat?.name}
                      />
                    </div>
                    <h5 className="mt-2 text-sm text-gray-900 font-medium">
                      {cat?.name}
                    </h5>
                  </Link>
                </div>
              ))}
        </div>
      </div>
    </section>
  );
};

export default HomeCat;
